import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'

const ReaderNavigationItem = props => {
  return (
    <li
      className={
        props.toolbarRow.node === props.pageroot
          ? 'toolbar_item active'
          : 'toolbar_item'
      }
    >
      <a className="toolbar_item_link" href={props.toolbarRow.url}>
        <div className="toolbar_item_row clearfix">
          <div className="toolbar_item_title text-dark">
            {props.displaySectionNumbers ? props.toolbarRow.label + ' ' : ''}
            {props.toolbarRow.title}
            {props.toolbarRow.node === props.pageroot ? (
              <span className="sr-only">
                {formatMessage('This is the current section.')}
              </span>
            ) : (
              <div />
            )}
          </div>
        </div>
      </a>
    </li>
  )
}

ReaderNavigationItem.propTypes = {
  toolbarRow: PropTypes.object.isRequired,
  displaySectionNumbers: PropTypes.bool.isRequired,
  pageroot: PropTypes.string.isRequired,
}

export default ReaderNavigationItem
